import { Button, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

interface RegionResetButtonProps {
    onReset: () => void;
    disabled?: boolean;
}

/**
 * Puts the region back where the panel would have seeded it — at the
 * crosshair for a lesion-scaled region, centred for a scan-scaled one.
 *
 * The way back from a region dragged off the anatomy, off the image, or
 * onto the wrong lesion: the seed only runs when no region exists, so
 * without this the only recovery is to drag every face back by hand,
 * and for a region already off-slab there is nothing left on screen to
 * grab.
 */
export default function RegionResetButton({
    onReset,
    disabled,
}: RegionResetButtonProps) {
    const intl = useIntl();
    return (
        <Tooltip
            title={intl.formatMessage({
                id: 'regionRestriction.resetTooltip',
            })}
            placement="right"
        >
            {/* Span wrapper: a disabled MUI Button fires no events, so the
                tooltip explaining WHY would not open on the one state the
                user needs it in. */}
            <span>
                <Button
                    size="small"
                    variant="text"
                    onClick={onReset}
                    disabled={disabled}
                    data-testid="threshold-seg-reset-region"
                    sx={{ fontSize: 11, textTransform: 'none', py: 0, px: 0.5 }}
                >
                    <FormattedMessage id="regionRestriction.reset" />
                </Button>
            </span>
        </Tooltip>
    );
}
